import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Sayfa bulunamadı" description="Aradığınız sayfa bulunamadı." />
      <section data-testid="not-found-page" className="pt-40 pb-24 px-6 bg-brand-offwhite min-h-[60vh] flex items-center">
        <div className="container-narrow text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">404</p>
          <h1 className="font-serif text-4xl md:text-5xl text-brand-green">Sayfa bulunamadı</h1>
          <p className="text-brand-text/70 mt-4">Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.</p>
          <div className="flex flex-wrap gap-3 justify-center mt-8">
            <Link to="/" data-testid="not-found-home" className="bg-brand-gold text-brand-offwhite px-6 py-3 rounded-sm text-sm font-semibold">Ana Sayfa</Link>
            <Link to="/arama" data-testid="not-found-search" className="border border-brand-gold text-brand-green px-6 py-3 rounded-sm text-sm font-semibold">Sitede Ara</Link>
          </div>
        </div>
      </section>
    </>
  );
}
